export default __webpack_public_path__ + "static/media/YassineBoutaharResume2022.4238c205.pdf";